import { Component } from 'preact'
import Header from '../../header'
import AlertComponent from '../../ui-components/AlertComponent'
import CategoryTabs from '../../category/control/CategoryTabs'
import KnowledgeBaseContent from './KnowledgeBaseContent'
import KnowledgeBaseCategoryDetails from './KnowledgeBaseCategoryDetails'
import KnowledgeBasePermissions from './KnowledgeBasePermissions'
import ConfirmationModal from '../../ui-components/ConfirmationModal'

class KnowledgeBaseCategoryEdit extends Component {
  constructor (props) {
    super(props)
    this.state = {
      messageType: null,
      message: null,
      category: props.category,
      showModal: false,
      isLoading: false,
      showConfirmation: false,
      showError: false,
      activeTab: 0,
      navigateTo: 0,
      saveUpdates: null
    }
    this.hasChanged = false
    this.categoryTabs = ['Content', 'Category Details', 'Permissions']
    this.showMessage = this.showMessage.bind(this)
    this.saveChanges = this.saveChanges.bind(this)
    this.discardChanges = this.discardChanges.bind(this)
    this.switchTab = this.switchTab.bind(this)
    this.closeConfirmation = this.closeConfirmation.bind(this)
    this.updateCategory = this.updateCategory.bind(this)
  }

  showMessage (messageType, message) {
    this.setState({ messageType, message, showConfirmation: false, isLoading: false }, () => {
      window.setTimeout(() => this.setState({ messageType: null, message: null }), 5000)
    })
  }

  updateCategory (newData) {
    this.setState({ category: Object.assign({}, this.state.category, { ...newData }) })
  }

  switchTab (activeTab) {
    if (this.hasChanged) {
      this.setState({ showConfirmation: true, navigateTo: activeTab })
    } else {
      this.setState({ activeTab, showConfirmation: false, isLoading: false })
    }
  }

  saveChanges () {
    this.setState({ isLoading: true })
    this.state.saveUpdates()
  }

  discardChanges () {
    this.state.discardChanges()
    this.setState({ showConfirmation: false })
  }

  closeConfirmation () {
    this.setState({ showConfirmation: false })
  }

  componentDidMount () {
    if (this.props.showSuccess) {
      this.showMessage('success', 'New category is added successfully!')
    }

    window.onbeforeunload = (e) => {
      if (!this.hasChanged) return
      e.preventDefault()
      e.returnValue = ''
    }
  }

  render (props, state) {
    const categoryDetails = {
      id: state.category.id,
      visibleTopics: state.category.visibleTopics,
      title: state.category.title,
      type: state.category.type,
      description: state.category.description,
      includeForStats: state.category.includeForStats,
      heroImage: state.category.heroImage,
      thumbnailImage: state.category.thumbnailImage
    }

    return (
      <div className='category-container category-edit_container'>
        <Header
          title='Edit category'
          disableCancelButton
          disableSaveButton
          hasBreadcrumb
          breadcrumbText='Back to Knowledge Base'
          breadcrumbLink={props.overviewLink}
        />
        <AlertComponent messageType={state.messageType} message={state.message} />
        <CategoryTabs
          tabs={this.categoryTabs}
          activeTab={state.activeTab}
          onCallback={(activeTab) => this.switchTab(activeTab)}
        />
        <ConfirmationModal
          isLoading={state.isLoading}
          enableModal={state.showConfirmation}
          title={<div>There are unsaved changes</div>}
          message={<div>If you leave this page, you’ll lose your changes</div>}
          buttons={
            [
              {
                text: 'Save changes',
                callback: this.saveChanges,
                class: 'btn btn-primary',
                showLoading: true
              },
              {
                text: 'Discard changes',
                callback: this.discardChanges,
                class: 'btn btn-default',
                showLoading: false
              }
            ]
          }
          onClose={this.closeConfirmation}
        />
        {
          this.categoryTabs[state.activeTab] === 'Content' ? (
            <KnowledgeBaseContent
              categoryId={state.category.id}
              updateCategory={this.updateCategory}
              list={state.category.order}
              saveUpdates={(saveFunction) => this.setState({ saveUpdates: saveFunction })}
              discardChanges={(resetFunction) => this.setState({ discardChanges: resetFunction })}
              showMessage={this.showMessage}
              hasTabChanges={hasChanged => { this.hasChanged = hasChanged }}
            />
          ) : null
        }
        {
          this.categoryTabs[state.activeTab] === 'Category Details' ? (
            <KnowledgeBaseCategoryDetails
              categoryDetails={categoryDetails}
              updateCategory={this.updateCategory}
              saveUpdates={(saveFunction) => this.setState({ saveUpdates: saveFunction })}
              discardChanges={(resetFunction) => this.setState({ discardChanges: resetFunction })}
              overviewLink={props.overviewLink}
              showMessage={this.showMessage}
              hasTabChanges={hasChanged => { this.hasChanged = hasChanged }}
            />
          ) : null
        }
        {
          this.categoryTabs[state.activeTab] === 'Permissions' ? (
            <KnowledgeBasePermissions
              saveUpdates={(saveFunction) => this.setState({ saveUpdates: saveFunction })}
              discardChanges={(resetFunction) => this.setState({ discardChanges: resetFunction })}
              categoryId={state.category.id}
              updateCategory={this.updateCategory}
              overviewLink={props.overviewLink}
              showMessage={this.showMessage}
              roles={props.roles}
              hasTabChanges={hasChanged => { this.hasChanged = hasChanged }}
            />
          ) : null
        }
      </div>
    )
  }
}

export default KnowledgeBaseCategoryEdit
